module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [(_vm.disabled) ? _c('div', {
    staticClass: "disabledOverflow",
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }) : _vm._e(), (_vm.groopsAreLoaded) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localSelectedGroup),
      expression: "localSelectedGroup"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.localSelectedGroup = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.$t('selectAGroup.placeholder')))]), _vm._l((_vm.groupsPerTypeAndUnused), function(groups, type) {
    return (type != 'UNUSED') ? [(type != 'undefined') ? _c('option', {
      attrs: {
        "disabled": "disabled"
      }
    }, [_vm._v(_vm._s(_vm.$t('groups.types.' + type)))]) : _vm._e(), _vm._l((groups), function(group, key) {
      return _c('option', {
        domProps: {
          "value": group
        }
      }, [(group.type) ? [_vm._v("   ")] : _vm._e(), _vm._v(_vm._s(group.name))], 2)
    })] : _vm._e()
  }), _vm._l((_vm.groupsPerTypeAndUnused), function(groups, type) {
    return (type == 'UNUSED') ? [(type != 'undefined') ? _c('option', {
      attrs: {
        "disabled": "disabled"
      }
    }, [_vm._v(_vm._s(_vm.$t('groups.types.' + type)))]) : _vm._e(), _vm._l((groups), function(group, key) {
      return _c('option', {
        domProps: {
          "value": group
        }
      }, [(group.type) ? [_vm._v("   ")] : _vm._e(), _vm._v(_vm._s(group.name))], 2)
    })] : _vm._e()
  })], 2) : [_c('div', {
    staticClass: "form-control"
  }, [_vm._v(_vm._s(_vm.$t("globals.loading")))])]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-600718f7","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SelectAGroup.vue
// module id = 886
// module chunks = 13